<script lang="ts">
  import Button from '$components/button/Button.svelte';
  import ModalPictureTextAction from '$components/modal-picture-text-action/ModalPictureTextAction.svelte';
  import { closeModal } from '$components/bottom-sheet/index.svelte';
  import Update from '$lib/assets/metri-header.webp';
  import { goToTransition } from '$utils/goToTransition';

  const seeChangelog = () => {
    closeModal();
    goToTransition('right', '/whats-new');
  };
</script>

<ModalPictureTextAction>
  {#snippet image()}
    <img src={Update} alt="Metri update" />
  {/snippet}
  {#snippet title()}
    Metri has been updated!
  {/snippet}
  {#snippet paragraph()}
    The app has been automatically updated to the latest version. To learn more about what changed,
    see the changelog.
  {/snippet}
  {#snippet action()}
    <Button stretched variant="tertiary" onclick={seeChangelog} ariaLabel="See changelog"
      >See What's New</Button>
    <Button stretched variant="plain" onclick={closeModal} ariaLabel="Close">Close</Button>
  {/snippet}
</ModalPictureTextAction>
